// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_cc-b";
export var colorBlue = "_cc-8";
export var colorDot = "_cc-0";
export var colorDotLarge = "_cc-2";
export var colorDotSmall = "_cc-1";
export var colorGreen = "_cc-7";
export var colorGrey = "_cc-3";
export var colorOrange = "_cc-5";
export var colorPink = "_cc-a";
export var colorPurple = "_cc-9";
export var colorRed = "_cc-4";
export var colorYellow = "_cc-6";